import { createSlice } from '@reduxjs/toolkit';

import { getPrevNextIds } from '../../helpers/common';

import {
  createNewGateway,
  deleteGateway,
  fetchAdminGateway,
  fetchGateway,
  fetchGateways,
  getAllGateways,
  searchGateways,
  updateGateway
} from '../actions/gateway';

const gatewaySlice = createSlice({
  name: 'gateway',
  initialState: {
    error: null,
    gateway: {},
    gateways: [],
    gatewaysAll: [],
    loading: false,
    sortedData: []
  },
  reducers: {
    setSortedData: (state, action) => {
      state.sortedData = action.payload;
    }
  },
  extraReducers: builder => {
    builder
      // Create Gateway
      .addCase(createNewGateway.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createNewGateway.fulfilled, (state, action) => {
        state.loading = false;
        state.gateway = action.payload;
      })
      .addCase(createNewGateway.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch Gateways
      .addCase(fetchGateways.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGateways.fulfilled, (state, action) => {
        state.loading = false;
        state.gateways = action.payload;
      })
      .addCase(fetchGateways.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      // Fetch All Gateways
      .addCase(getAllGateways.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllGateways.fulfilled, (state, action) => {
        state.gatewaysAll = action.payload;
        state.loading = false;
      })
      .addCase(getAllGateways.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      // Fetch Gateway by Search Query
      .addCase(searchGateways.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(searchGateways.fulfilled, (state, action) => {
        state.gateways = action.payload;
        state.loading = false;
      })
      .addCase(searchGateways.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch Gateway
      .addCase(fetchGateway.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGateway.fulfilled, (state, action) => {
        const { prev_id, next_id } = state.sortedData?.length
          ? getPrevNextIds(state.sortedData, action.payload?.id)
          : { prev_id: action.payload.prev_id, next_id: action.payload.next_id };
        state.gateway = { ...action.payload, prev_id, next_id };
        state.loading = false;
      })
      .addCase(fetchGateway.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      // Fetch Admin Gateway
      .addCase(fetchAdminGateway.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAdminGateway.fulfilled, (state, action) => {
        const { prev_id, next_id } = state.sortedData?.length
          ? getPrevNextIds(state.sortedData, action.payload?.id)
          : { prev_id: action.payload.prev_id, next_id: action.payload.next_id };
        state.gateway = { ...action.payload, prev_id, next_id };
        state.loading = false;
      })
      .addCase(fetchAdminGateway.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      // Update Gateway
      .addCase(updateGateway.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateGateway.fulfilled, (state, action) => {
        state.loading = false;
        state.gateway = action.payload;
      })
      .addCase(updateGateway.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Delete Gateway
      .addCase(deleteGateway.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteGateway.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteGateway.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { setSortedData } = gatewaySlice.actions;
export default gatewaySlice.reducer;
